import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../../../configuration/setup/store.ts';
import type { AssetWithDevices } from '../../AssetsHelpGang.tsx';

interface AssetSidebarState {
    selectedAsset?: AssetWithDevices;
    assetModified: boolean;
}

const initialState: AssetSidebarState = {
    selectedAsset: undefined,
    assetModified: false,
};

const assetSidebarSlice = createSlice({
    name: 'assetSidebar',
    initialState,
    reducers: {
        assetSelected: (state, action: PayloadAction<AssetWithDevices | undefined>) => {
            state.selectedAsset = action.payload;
            state.assetModified = false;
        },
        resetAssetSidebar: state => {
            state.selectedAsset = undefined;
            state.assetModified = false;
        },

        assetModified: state => {
            state.selectedAsset = undefined;
            state.assetModified = true;
        },
    },
});

export const getSidebarAsset = (state: RootState) => state.assetSidebar.selectedAsset;
export const getSidebarAssetModified = (state: RootState) => state.assetSidebar.assetModified;

export const assetSidebarReducer = assetSidebarSlice.reducer;
export const { assetSelected, resetAssetSidebar, assetModified } = assetSidebarSlice.actions;
